import { Component } from '@angular/core';
import { ModalsService } from "../../../../../common/src/lib/services/modals.service";
import { ItemsService } from "../../services/items.service";
import { map } from "rxjs/operators";

@Component({
  selector: 'app-workflow-item-info-mobile',
  templateUrl: './workflow-item-info-mobile.component.html',
  styleUrls: ['./workflow-item-info-mobile.component.scss']
})
export class WorkflowItemInfoMobileComponent {

  edited = false;
  warning = false;

  itemStatus$ = this.itemsService.itemObservable(this.data.item.name).pipe(
    map(item => {
      if (!item || !item.name)
        return 'warning';

      if (
        item.description !== this.data.item.description
        || item.price !== this.data.item.price
        || item.cost !== this.data.item.cost
        || item.taxable !== this.data.item.taxable
      )
        return 'edited';

      return 'empty';
    })
  );

  get data(): any {
    return this.modalsService.data;
  }

  get taxPercentage() {
    return this.modalsService.data.salesTaxPercentage;
  }

  constructor(
      private modalsService: ModalsService,
      private itemsService: ItemsService
  ) { }

  async close() {
    await this.modalsService.close();
  }

  getMarkup(): number {
    if (!this.data.item.cost)
      return 100;

    return ((this.data.item.price-this.data.item.cost)/this.data.item.cost)*100;
  }

  getTaxAmount(): number {
    if (!this.data.item.taxable)
      return 0;

    const discountedPrice = this.data.item.discountAmount
        ? this.data.item.price - this.data.item.discountAmount
        : this.data.item.price;
    return discountedPrice*this.taxPercentage/100;
  }

  getTotal(): number {
    const discounted = this.data.item.discountAmount
        ? this.data.item.price - this.data.item.discountAmount
        : this.data.item.price;

    return this.data.item.taxable
      ? discounted + (discounted*this.taxPercentage/100)
      : discounted;
  }
}
